import React from "react";

const Lowest = ({ title }) => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width={15}>
        <path
          d="M12.504883 8.14541c.5-.3 1.1-.1 1.4.4s.1 1-.4 1.3l-5 3c-.3.2-.7.2-1 0l-5-3c-.5-.3-.6-.9-.3-1.4.2-.4.8-.6 1.3-.3l4.5 2.7 4.5-2.7z"
          fill="#0065ff"
        />
        <path
          d="M12.504883 3.84541c.5-.3 1.1-.2 1.4.3s.1 1.1-.4 1.4l-5 3c-.3.2-.7.2-1 0l-5-3c-.5-.3-.6-.9-.3-1.4.3-.5.9-.6 1.4-.3l4.4 2.7 4.5-2.7z"
          fill="#2684ff"
        />
      </svg>
    </span>
  );
};

export default Lowest;
